define('lq/events/actions/sap',[
    'lq/events/actions/eventAction',
    'jquery'
], function (EventAction, $) {
    'use strict';

    function SAP(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(SAP, EventAction);

    SAP.typeName = 'SAP';

    SAP.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    SAP.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;

        var drop = this.piping.dropFactory.findDropById(self.eventData.morphId);
        if (drop) {
            drop.execute();
        }

        continuation();
    };

    return SAP;
});
